import { render, staticRenderFns } from "./LimpiezaView.vue?vue&type=template&id=17fb4872"
import script from "./LimpiezaView.vue?vue&type=script&lang=js"
export * from "./LimpiezaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports